<div class="term-container mat-small">
  <h2 class="term-title">Patron Card Policy</h2>
  <br/>
  <div [innerHTML]="organizationSelectors.opacCardPolicy | select"></div>
</div>
